
import React from 'react';
import { withRouter } from 'react-router-dom';
import { Grid, AppBar } from '@material-ui/core';
import Toolbar from '@material-ui/core/Toolbar';
import TitleIco from '../../../styles/images/Base.svg';

function Banner(props) {
    return (
        <Grid item>
            {/* <div className="banner-container"> */}
            <AppBar color="default" position='fixed' className="banner-appbar">
                <Toolbar variant="dense" className="toolbar">
                    <div style={{ display: "flex", alignItems: "center" }}>
                        <img src={TitleIco} alt="title-ico" className="banner-ico" draggable="false" />
                    </div>
                </Toolbar>
            </AppBar>
            {/* </div > */}
        </Grid>

    );
}

export default withRouter(Banner);